const inFlight = new Map();

export const dedupe = (key, fetcher) => {
  if (inFlight.has(key)) return inFlight.get(key);
  const promise = Promise.resolve()
    .then(() => fetcher())
    .finally(() => {
      inFlight.delete(key);
    });
  inFlight.set(key, promise);
  return promise;
};

export const clearDedupe = (keyPrefix) => {
  if (!keyPrefix) {
    inFlight.clear();
    return;
  }
  for (const k of inFlight.keys()) {
    if (k.startsWith(keyPrefix)) inFlight.delete(k);
  }
};
